/**
 * Formats a number for display without rounding.
 * Shows the exact value with trailing zeros removed (e.g. 10.5 not 10.50).
 */
export function formatAmountExact(value: number | null | undefined): string {
  if (value == null || Number.isNaN(value)) return '0';
  const num = Number(value);
  const str = num.toString();
  // Expand scientific notation to avoid values like 1e-7
  if (str.includes('e')) {
    return num.toFixed(12).replace(/\.?0+$/, '');
  }
  return str.replace(/\.?0+$/, '');
}
